export const FilterIcon = () => {
  return <img src="/media/icons/filterIcon.svg" width={16} height={16} />;
};


export const FilterIconLight = () => {
  return <img src="/media/icons/filter-light.png" width={16} height={16} />;
};

export const ColumnsIcon = () => {
  return <img src="/media/icons/columns.png" width={24} height={24} />;
};
